module.exports = __webpack_public_path__ + "img/logo@2x.9e713e4d.png";